// @ts-nocheck

import { createSelector } from 'reselect';

import { selectRegulationMessage } from '../../selectors/core/regulationPrimary.selector';

const selectShow = createSelector([selectRegulationMessage], (message) => !!message);

const selectRealityCheckModalProps = createSelector([selectShow], (show) => ({
  show,
}));

export default selectRealityCheckModalProps;
